import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { DeviceInfoService } from '../deviceInfo.service';
import { ErrorData } from './error-handler.base.service';
import { isPlatformBrowser } from '@angular/common';
import { Firestore, collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { FIREBASE_FIRESTORE } from '@awo-care/shared-firebase';

@Injectable({ providedIn: 'root' })
export class ErrorStorageService {
  private firestore = inject(FIREBASE_FIRESTORE);
  private deviceInfoService = inject(DeviceInfoService);
  private platformId = inject(PLATFORM_ID);

  async storeError(errorData: ErrorData): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      console.warn('Error reporting skipped - not in browser environment');
      return;
    }

    try {
      const deviceInfo = this.deviceInfoService.getDeviceInfo();

      if (!errorData.errorData) {
        console.warn('Missing Error Data - skipping error storage');
        return;
      }

      const errorMessage = {
        createdOn: serverTimestamp(),
        ...errorData,
        deviceInfo,
        errorData: this.sanitizeErrorData(errorData.errorData),
      };

      const docRef = doc(collection(this.firestore, 'uiErrorLog'));
      await setDoc(docRef, errorMessage);
    } catch (error) {
      console.error('Failed to store error data:', error);
    }
  }

  private sanitizeErrorData(errorData: unknown): unknown {
    const sanitized = JSON.parse(JSON.stringify(errorData));
    delete sanitized.screenshot;
    return sanitized;
  }
}
